export class CeCloudNotificationsTargetApplicationsDB {

    public static targetApplications = [
      {
        "label": "STAND",
        "code": "standMobApp",
        "enabled": true
      },
      {
        "label": "ADMINCENTER",
        "code": "adminCenterSPA",
        "enabled": false
      },
      {
        "label": "CONTROLLERCMS",
        "code": "spa",
        "enabled": false
      }
    ]      
}